import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { VentureApiResponse, VentureResponse } from "../types/ventures-types";

export const fetchVenture = createAsyncThunk(
  "project/fetchProject",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<VentureApiResponse>(
        `/ventures/${id}?populate=*`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type VentureState = {
  venture: null | VentureResponse;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: VentureState = {
  venture: null,
  status: "idle",
  error: null,
};

const ventureSlice = createSlice({
  name: "ventures",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVenture.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVenture.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.venture = action.payload.data;
      })
      .addCase(fetchVenture.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default ventureSlice.reducer;
